export enum WebsocketClientType {
  None = '',
  Display = 'WebsocketClientType_Display',
  Menu = 'WebsocketClientType_Menu',
  Template = 'WebsocketClientType_Template'
}
